import React, { useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../services/pbumku/PbumkuService";

const JenisSertifikasi = ({kodeSert, jenisSertifikasi}) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    const [uraianSertifikasi, setUraianSertifikasi] = useState('')

    useEffect(() => {
        const getUraianSertifikasi = async () => {
            const response = await pbumkuService.getJenisSertifikasi(kodeSert, jenisSertifikasi)
            setUraianSertifikasi(response?.data?.uraianSertifikasi ?? '-')
        }
        getUraianSertifikasi()
    }, [pbumkuService, kodeSert, jenisSertifikasi])

    return (
        <>{uraianSertifikasi}</>
    )
}

export default JenisSertifikasi